// Polyfills
import 'core-js/features/promise';
import 'core-js/features/object/assign';
import 'core-js/features/array/from';
// Global app styles
import 'src/assets/css/ibfrs.css';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { enableES5 } from 'immer';
import { register } from 'src/serviceWorker';
import { store, persistor } from 'src/redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import App from 'src/App';
import { EnvProvider, AuthProvider } from './contexts';
import { PageRefsProvider } from './contexts/PageRefsContext';
import {
  PreferencesProvider,
  BroadCastProvider,
  OverlayProvider
} from './contexts';

const path = window.location.pathname;
const isPortalApp = path.startsWith('/portal');
enableES5();

ReactDOM.render(
  // <React.StrictMode>
  <ReduxProvider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AuthProvider>
        <PreferencesProvider>
          <EnvProvider>
            <BrowserRouter>
              <PageRefsProvider>
                <OverlayProvider>
                  <BroadCastProvider>
                    <App />
                  </BroadCastProvider>
                </OverlayProvider>{' '}
              </PageRefsProvider>
            </BrowserRouter>
          </EnvProvider>
        </PreferencesProvider>
      </AuthProvider>
    </PersistGate>
  </ReduxProvider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

register();
